module.exports = __webpack_public_path__ + "media/submital_required_photos/rp_lateral_izquierdo-d2e7a9ad.webp";